import type { TableColumn } from "../../../../../../components/table";

export const tableColumns: TableColumn<any>[] = [
  {
    title: "STT",
    size: "medium",
    renderCell: (row, index) => index,
  },
  {
    title: "Tên vật tư",
    renderCell: (row) => row.NameSupplies,
  },
  {
    title: "Đơn vị tính",
    renderCell: (row) => row.Unit,
  },
  {
    title: "Số lượng",
    renderCell: (row) => row.Amount,
  },
  {
    title: "Đơn giá",
    renderCell: (row) => row.UnitPrice,
  },
  {
    title: "Thành tiền",
    renderCell: (row) => row.IntoMoney,
  },
  {
    title: "Nguồn vật tư",
    renderCell: (row) => row.Plan,
  },
  {
    title: "Ghi chú",
    renderCell: (row) => row.Notes,
  },
];
